import { Person } from '@eadsysteme/ewsrealestateclient-v3';
import { RoleSetting } from '@eadsysteme/energyefficiencyclient-v1';
import { Dayjs } from 'dayjs';

export class RoleModel {
	// TODO Replace with real Role Interface
	id?: string;
	person: Person;
	roles: Role[];
	propertyManagementNumber?: string;
	isVacancy?: boolean;
	isHighlighting: boolean;

	public constructor() {}
}

export enum SalutationEnum {
	Mr = 'MR',
	Mrs = 'MRS',
	Div = 'DIV',
	Company = 'COMPANY',
	Family = 'FAMILY',
	Unknown = 'UNKNOWN',
}

export interface Role {
	id?: string;
	roleType: RoleType;
	validFrom?: Dayjs;
	validTo?: Dayjs;
	isOverlappingValidFrom?: boolean;
	isOverlappingValidTo?: boolean;
	isIncompleteValidFrom?: boolean;
	isIncompleteValidTo?: boolean;
	roleSetting?: RoleSetting;
	propertyManagementNumber?: string;
	uviReception?: string;
	tenantNumber?: string;
	endOtherRolesToo?: boolean;
}

export const UiRoleType = {
	OWNER: RoleSetting.RoleTypeEnum.OWNER,
	RESIDENT: RoleSetting.RoleTypeEnum.RESIDENT,
	TENANT: RoleSetting.RoleTypeEnum.TENANT,
	VACANCY: RoleSetting.RoleTypeEnum.VACANCY,
	CONSUMPTION_INFO_RECEIVER: 'CONSUMPTION_INFO_RECEIVER',
} as const;
export type UiRoleType = (typeof UiRoleType)[keyof typeof UiRoleType];
export type RoleType = UiRoleType;

export interface ActiveRoleWithoutEndDate {
	roleId: string;
	roleType: RoleType;
	name: string;
	person?: Person;
	validFrom?: Dayjs;
	propertyManagementNumber?: string;
}
